export default __webpack_public_path__ + "static/media/Close_Menu.e7ba06ef.svg";